import { render, staticRenderFns } from "./FundsTransferCheckersQueue.vue?vue&type=template&id=1b2a2da8&"
import script from "./FundsTransferCheckersQueue.vue?vue&type=script&lang=js&"
export * from "./FundsTransferCheckersQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports